module.exports = __webpack_public_path__ + "static/media/dis-goods.dab02a1d.png";